import type {LanguageSelectorTranslation} from './languageSelectorTranslationType';
import type {ChatCoffeeLocaleId} from '../localeLoaders';
import type {ComponentTranslationServerDefinition} from 'microsites/core/chatMicrosite/translations/componentTranslations';

type LanguageSelectorTranslationModule = {
  translation: LanguageSelectorTranslation;
};

const createLoader = (locale: ChatCoffeeLocaleId) => (): LanguageSelectorTranslation => {
  const translationModule = require(`./translations/${locale}.ts`) as LanguageSelectorTranslationModule;
  return translationModule.translation;
};

const languageSelectorTranslationSyncLoaders: Record<ChatCoffeeLocaleId, () => LanguageSelectorTranslation> = {
  'ar-MA': createLoader(`ar-MA`),
  'ar-SA': createLoader(`ar-SA`),
  'de-DE': createLoader(`de-DE`),
  'en-KE': createLoader(`en-KE`),
  'en-NG': createLoader(`en-NG`),
  'en-US': createLoader(`en-US`),
  'es-ES': createLoader(`es-ES`),
  'fa-IR': createLoader(`fa-IR`),
  'fr-FR': createLoader(`fr-FR`),
  'hi-IN': createLoader(`hi-IN`),
  'it-IT': createLoader(`it-IT`),
  'ja-JP': createLoader(`ja-JP`),
  'ko-KR': createLoader(`ko-KR`),
  'nl-NL': createLoader(`nl-NL`),
  'pt-PT': createLoader(`pt-PT`),
  'ru-RU': createLoader(`ru-RU`),
  'sv-SE': createLoader(`sv-SE`),
  'th-TH': createLoader(`th-TH`),
  'yue-Hant-HK': createLoader(`yue-Hant-HK`),
  'zh-Hans-CN': createLoader(`zh-Hans-CN`),
};

export const languageSelectorTranslationDefinition: ComponentTranslationServerDefinition<LanguageSelectorTranslation> = {
  cacheKey: `languageSelector`,
  syncLoaders: languageSelectorTranslationSyncLoaders,
};
